import { cn } from '../../lib/cn'
import { LoadingSpinner } from './LoadingSpinner'

interface LoadingStateProps {
  className?: string
  /** Centers within the full viewport (use outside the app shell, e.g. login). */
  fullPage?: boolean
  /** Centers within the app-shell content area (use when the page body is just the spinner). */
  page?: boolean
  inline?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export function LoadingState({
  className,
  fullPage = false,
  page = false,
  inline = false,
  size = 'md',
}: LoadingStateProps) {
  if (inline) {
    return (
      <span className={cn('inline-flex items-center justify-center', className)}>
        <LoadingSpinner size={size} />
      </span>
    )
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center',
        fullPage ? 'min-h-screen' : page ? 'min-h-[calc(100vh-7rem)]' : 'py-8',
        className,
      )}
    >
      <LoadingSpinner size={size} />
    </div>
  )
}
